import React from 'react';

import FreeText from './../overlays/FreeText';
import Crawl from './../overlays/Crawl';
import LineUp from './../overlays/LineUp';
import Overlay from './../overlays/Overlay'
import Bowl from './../overlays/Bowl'

class DriftMapping extends React.Component {

  constructor(props) {
    super(props);
  }

  render () {
    return (
      <>
      <Overlay stateName="Drift_button_big_vs" display={this.props.display} theme={this.props.theme} overlayConf="Drift_full_vs"/>
      <Overlay stateName="Drift_button_small_vs" display={this.props.display} theme={this.props.theme} overlayConf="Drift_small_vs"/>
      <Overlay stateName="Drift_button_score_table_16" display={this.props.display} theme={this.props.theme} overlayConf="Drift_score_table"/>
      <Overlay stateName="Drift_button_score_table_32" display={this.props.display} theme={this.props.theme} overlayConf="Drift_score_table"/>
      <Overlay stateName="Drift_button_double_score_table_0" display={this.props.display} theme={this.props.theme} overlayConf="Drift_double_score_table"/>
      <Overlay stateName="Drift_button_double_score_table_32" display={this.props.display} theme={this.props.theme} overlayConf="Drift_double_score_table"/>
      <Overlay stateName="Drift_button_double_score_table_64" display={this.props.display} theme={this.props.theme} overlayConf="Drift_double_score_table"/>
      <Overlay stateName="Drift_button_double_score_table_96" display={this.props.display} theme={this.props.theme} overlayConf="Drift_double_score_table"/>
      <Overlay stateName="Drift_button_quailifying_player_round_1" display={this.props.display} theme={this.props.theme} overlayConf="Drift_quailifying_player"/>
      <Overlay stateName="Drift_button_quailifying_player_round_2" display={this.props.display} theme={this.props.theme} overlayConf="Drift_quailifying_player"/>
      <Overlay stateName="Drift_button_quailifying_player_round_3" display={this.props.display} theme={this.props.theme} overlayConf="Drift_quailifying_player"/>
      <Overlay stateName="Drift_current_session_battle_32" display={this.props.display} theme={this.props.theme} overlayConf="Drift_current_session"/>
      <Overlay stateName="Drift_current_session_battle_16" display={this.props.display} theme={this.props.theme} overlayConf="Drift_current_session"/>
      <Overlay stateName="Drift_current_session_quailifying" display={this.props.display} theme={this.props.theme} overlayConf="Drift_current_session"/>
      <Overlay stateName="Drift_current_session_finals" display={this.props.display} theme={this.props.theme} overlayConf="Drift_current_session"/>
      <Overlay stateName="Drift_current_session_free_training" display={this.props.display} theme={this.props.theme} overlayConf="Drift_current_session"/>
      <Overlay stateName="Drift_button_battleboard_32" display={this.props.display} theme={this.props.theme} overlayConf="Drift_battle_top_32"/>
      <FreeText stateName="Drift_button_freetext" display={this.props.display}  theme={this.props.theme} overlayConf="Drift_freetext"/>
      <Crawl stateName="Drift_button_freetext_crawl" display={this.props.display}  theme={this.props.theme} overlayConf="Drift_freetext_crawl"/>
    </>

    );
  }

}
export default DriftMapping;
